/**
 * Конверт улики: расширение → вкладка сканера → шкаф.
 *
 * Сеть расширение не трогает. Клип уезжает тем же мостиком, что промахи
 * прицела: страница forq.ru сама пишет в журнал. Пульс клипы в стол кладёт,
 * в шкаф — нет (`pulse: true`).
 */

import { parseClips, type PageClip } from './clip';

export const SHELF = 'forq:shelf';

export function shelfEnvelope(
  clips: readonly PageClip[],
  pulse = false,
): { channel: string; clips: PageClip[]; pulse?: boolean } {
  return pulse
    ? { channel: SHELF, clips: [...clips], pulse: true }
    : { channel: SHELF, clips: [...clips] };
}

export function parseShelf(data: unknown): { clips: PageClip[]; pulse: boolean } | null {
  if (typeof data !== 'object' || data === null) return null;
  if ((data as { channel?: unknown }).channel !== SHELF) return null;
  const clips = parseClips((data as { clips?: unknown }).clips);
  if (clips === null) return null;
  return { clips, pulse: (data as { pulse?: unknown }).pulse === true };
}
